import styled from 'styled-components/macro';

export const Loader = styled.div`
  width: 100%;
  margin: 20px 0;
`;
